export const toCountFormat = (value: number): string => {
	const format = (value: number) => Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format(value)

	if (value < 1_000) return `${format(value)}`
	if (value < 1_000_000) return `${format(value / 1_000)} K`
	if (value < 1_000_000_000) return `${format(value / 1_000_000)} M`
	return `${format(value / 1_000_000_000)} B`
}

export function toNumberFormat(value: number): string {
	return Intl.NumberFormat(undefined).format(value)
}

export const toSizeFormat = (value: number): string => {
	const format = (value: number) => Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(value)

	if (value < 1_000) return `${format(value)} B`
	if (value < 1_000_000) return `${format(value / 1_000)} KB`
	if (value < 1_000_000_000) return `${format(value / 1_000_000)} MB`
	if (value < 1_000_000_000_000) return `${format(value / 1_000_000_000)} GB`
	return `${format(value / 1_000_000_000_000)} TB`
}

export const parseNumber = (value: string | null | undefined): number | null => {
	const trimmedValue = value?.trim() ?? ""
	if (trimmedValue === "") return null
	const number = Number(trimmedValue)
	return !isNaN(number) ? number : null
}

export const parseIntNumber = (value: string | null | undefined): number | null => {
	const number = parseNumber(value)
	if (number === null) return null
	if (!Number.isInteger(number)) return null
	return number
}

export function clampNumber(value: number, min: number, max: number): number {
	return Math.min(Math.max(value, min), max)
}
